import { useQuery } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';

function getSharedSchools(): Promise<SharedSchool[]> {
  return request('/schools/shared', {
    method: 'GET',
  }).then(res => res.data);
}

export interface SharedSchool {
  id: string;
  name: string;
  ownerEmail: string;
  isOwner: boolean;
}

export const SHARED_SCHOOLS_KEY = 'shared-schools';

export function useSharedSchools() {
  return useQuery({
    queryKey: [SHARED_SCHOOLS_KEY],
    queryFn: () => getSharedSchools(),
    staleTime: 60 * 1000, // to keep data up to date from other peers' actions
  });
}
